/**
 * Prev/next arrows for the custom-content mobile swipe slider.
 * Renders below the slider when "Activer le balayage sur mobile" is enabled.
 * The slider is a native scroll container (.f-swiper), so the arrows scroll it
 * by one column per click and disable themselves at each end.
 */
if (!customElements.get("f-swiper-nav")) {
  class FSwiperNav extends HTMLElement {
    connectedCallback() {
      this.swiper = this.previousElementSibling;
      if (!this.swiper || !this.swiper.classList.contains("f-swiper")) {
        this.swiper = this.parentElement.querySelector(".f-swiper");
      }
      if (!this.swiper) return;

      this.prevBtn = this.querySelector(".previous");
      this.nextBtn = this.querySelector(".next");

      this.prevBtn && this.prevBtn.addEventListener("click", () => this.scrollByPage(-1));
      this.nextBtn && this.nextBtn.addEventListener("click", () => this.scrollByPage(1));
      this.swiper.addEventListener("scroll", () => this.updateState(), { passive: true });

      this.updateState();
    }

    step() {
      const col = this.swiper.querySelector(".f-column");
      if (!col) return this.swiper.clientWidth;
      const style = getComputedStyle(this.swiper);
      const gap = parseFloat(style.columnGap || style.gap || "0") || 0;
      return col.getBoundingClientRect().width + gap;
    }

    scrollByPage(direction) {
      this.swiper.scrollBy({ left: direction * this.step(), behavior: "smooth" });
    }

    updateState() {
      const max = this.swiper.scrollWidth - this.swiper.clientWidth - 1;
      this.prevBtn && this.prevBtn.toggleAttribute("disabled", this.swiper.scrollLeft <= 0);
      this.nextBtn && this.nextBtn.toggleAttribute("disabled", this.swiper.scrollLeft >= max);
    }
  }

  customElements.define("f-swiper-nav", FSwiperNav);
}
